<template>
	<b-card no-body>
		<b-card-header class="p-2 d-flex justify-content-between align-items-center">
			<h4 class="mb-0">Redemption Details</h4>
			<div class="d-flex align-items-center text-primary">
				<!-- <el-button type="default" plain size="small" icon="el-icon-download">
					Redemption Statement
				</el-button> -->
				<el-button type="primary" plain size="small" icon="el-icon-plus" @click.native="openModal()">
					Add Redemption
				</el-button>
			</div>
		</b-card-header>
		<div class="table-listings">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%" size="mini" v-loading="is_loading">
				<el-table-column type="expand">
					<template slot-scope="props">
						<div class="p-1">
							<RedemptionDetailItem :redemption="props.row" />
						</div>
					</template>
				</el-table-column>
				<el-table-column label="Request Date" min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Request<br>Date</span>
					</template>
					<template slot-scope="scope">
						{{ _gHlp.formatMomentDate(scope.row.request_date || scope.row.created_at , 'D MMM, YYYY') }}
					</template>
				</el-table-column>
				<el-table-column label="Redemption Date" min-width="120" label-class-name="py-0">
					<template slot="header">
						<small>Redemp. Date<br />Efective Date</small>
					</template>
					<template slot-scope="scope">
						{{ _gHlp.formatMomentDate(scope.row.redem_date, 'D MMM, YYYY') }} <br /> {{
							_gHlp.formatMomentDate(getEffectiveDate(scope.row), 'D MMM, YYYY') }}
					</template>
				</el-table-column>
				<el-table-column label="Paid Status" min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Paid Status</span>
					</template>
					<template slot-scope="scope">
						{{ _gHlp.getValue(scope.row, 'paid_status', '-') }}
					</template>
				</el-table-column>
				<el-table-column label="Interest" min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Interest <br /> <small>Amt. (RM)</small></span>
					</template>
					<template slot-scope="scope">
						{{ scope.row.total_interest | moneyFormatter }}
					</template>
				</el-table-column>
				<el-table-column label="Settlement" min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Settlement <br /> <small>Amt. (RM)</small></span>
					</template>
					<template slot-scope="scope">
						{{ scope.row.total_repayment | moneyFormatter }}
					</template>
				</el-table-column>
				<el-table-column label="Settlement" min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Attchment</span>
					</template>
					<template slot-scope="scope">
						<div class="btn btn-icon btn-sm btn-primary rounded-circle cursor-pointer"
							@click="openModal(scope.row, true)">{{ scope.row.total_attachment }}</div>
					</template>
				</el-table-column>
				<el-table-column label="Status" min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Status</span>
					</template>
					<template slot-scope="scope">
						<div v-if="!_gHlp.isEmpty(scope.row.apv_id)">
							<div class="d-flex justify-content-start align-items-center"
								v-if="(_gHlp.checkAccess(['role_credit_head', 'role_credit_manager', 'role_admin', 'role_super_admin']) || (!_gHlp.checkAccess(['collection_approval'])))">
								<el-button type="success" plain size="mini" @click="updateApprovalStatus(scope.row.apv_id, 'Approved')"
									icon="el-icon-check">
									Approve
								</el-button>
								<el-button type="danger" plain size="mini" @click="updateApprovalStatus(scope.row.apv_id, 'Rejected')"
									icon="el-icon-close">
									Reject
								</el-button>
							</div>
							<small v-else>
								<i>Waiting Approval</i>
							</small>
						</div>
						<div v-else>
							<!-- hide update balance before all item approved  -->
							<el-dropdown trigger="click" v-model="scope.row.status" style="cursor: pointer;"
								:disabled="scope.row.status != 'Pending'" @command="updateStatusRedemption">
								<p class="el-dropdown-link top-line">
									<span class="d-inline-block text-truncate " :class="_gConst.getColor(scope.row.status)"
										style="max-width: 150px; overflow: unset;">{{ scope.row.status }}</span>
									<i class="el-icon-caret-bottom el-icon--right" v-if="scope.row.status == 'Pending'"></i>
								</p>
								<el-dropdown-menu slot="dropdown">
									<div style="max-height: 300px;overflow-y: auto;">
										<el-dropdown-item v-for="(itm, index) in statusList" :key="index"
											:command="{ redem_id: scope.row.redem_id, status: itm }">{{ itm }}</el-dropdown-item>
									</div>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</template>
				</el-table-column>
				<el-table-column min-width="150" label-class-name="py-0">
					<template slot="header">
						<span class="text-break"></span>
					</template>
					<template slot-scope="scope">
						<div>
							<el-button type="primary" size="mini" icon="el-icon-download" @click.native="$refs.doc_redemption_letter.show(scope.row)">
								<small>Redm. Statement</small>
							</el-button>
						</div>
					</template>
				</el-table-column>	
				<el-table-column min-width="40" label-class-name="py-0">
					<template slot="header">
						<span class="text-break"></span>
					</template>
					<template slot-scope="scope">
						<el-dropdown trigger="click" style="cursor: pointer">
							<p class="el-dropdown-link mb-0 top-line">
								<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="openModal(scope.row)">
									<!-- Eye Icon -->
									<b-icon icon="pencil-square" class="mr-1" variant="gray"></b-icon>
									Edit
								</el-dropdown-item>
								<el-dropdown-item @click.native="recalculate(scope.row.redem_id)" v-if="scope.row.status == 'Pending'">
									<!-- Eye Icon -->
									<b-icon icon="calculator" class="mr-1" variant="gray"></b-icon>
									Recalculate
								</el-dropdown-item>
								<el-dropdown-item @click.native="remove(scope.row.redem_id)" v-if="scope.row.paid_status != 'Paid'">
									<span class="text-danger">
										<!-- Trash-Can Icon -->
										<b-icon icon="trash" class="mr-1" variant="gray"></b-icon>
										Delete
									</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>

			</el-table>
		</div>

		<ModalAddRedemption ref="modal_add_redemption" @closeModal="closeModal($event)" />
		<DrawerRedemptionHistory ref="drawer_redemption_history" />
		<DocRedemptionLetter ref="doc_redemption_letter" />
	</b-card>
</template>
<script>
import { Button, DropdownMenu, DropdownItem, Dropdown, Table, TableColumn } from 'element-ui'
import RedemptionDetailItem from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Redemption/RedemptionDetailItem'
import ModalAddRedemption from '@/views/CreditLoanCase/Modals/ModalAddRedemption'
import DrawerRedemptionHistory from '@/views/CreditLoanCase/Drawers/DrawerRedemptionHistory'
import DocRedemptionLetter from '@/views/CreditLoanCase/DocTemplate/DocRedemptionLetter';
import { cloneDeep } from 'lodash'
import { swal } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'
import { useApprovalStore } from '@/stores/approvalStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

export default {
	components: {
		DrawerRedemptionHistory,
		ModalAddRedemption,
		RedemptionDetailItem,
		DocRedemptionLetter,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			is_loading: false,
			tableData: []
		}
	},
	created() {
		this.getListing();
		gEventBus.$on('refresh-detail-redem', this.getListing)
	},
	beforeDestroy() {
		gEventBus.$off('refresh-detail-redem', this.getListing)
	},
	computed: {
		...mapState(useApprovalStore, ['activeApprovalList']),
		...mapState(useLoanCaseStore, ['activeCase']),
		// totalDebit() {
		// 	if (_gHlp.isEmpty(this.tableData)) return 0;
		// 	return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.debit), 0);
		// },
		// totalCredit() {
		// 	if (_gHlp.isEmpty(this.tableData)) return 0;
		// 	return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.credit), 0);
		// },
		statusList() {
			return (_gHlp.checkAccess(['role_credit_head', 'role_credit_manager', 'role_admin', 'role_super_admin']) || (!_gHlp.checkAccess(['collection_approval']))) ? ['Pending', 'Submitted', 'Approved', 'Rejected', 'Expired', 'Payment Received'] : ['Pending', 'Submitted', 'Expired', 'Payment Received'];
		}
	},
	methods: {
		...mapActions(useLoanCaseStore, ['getCase', 'getRedemList', 'updateRedem', 'updateCase', 'deleteRedem']),
		...mapActions(useApprovalStore, ['getAprovalList', 'updateApproval']),
		...mapActions(useNotificationStore, ['createBellNotif']),
		...mapActions(useMessagingStore, ['createSendEmail']),
		openModal(item = null, attachment_only = false) {
			// this.editData = item;
			this.$refs.modal_add_redemption.show(cloneDeep(item), attachment_only)
		},
		closeModal(refresh = false) {
			if (refresh) {
				this.getListing();
			}
		},
		getListing() {
			this.is_loading = true;
			this.getRedemList({ paginate: 'no_paginate' }).then(resp => {
				this.tableData = resp.data;
				this.is_loading = false;
			}).catch(err => {
				this.is_loading = false;
			});
		},
		getEffectiveDate(data){
			return !_gHlp.isEmpty(data.balance_date) ? data.balance_date : (!_gHlp.isEmpty(data.balance_first_date) ? data.balance_first_date : data.redem_date);
		},
		updateStatusRedemption(val) {
			let redem_id = val.redem_id;
			let status = val.status;

			swal.fire({
				title: 'Status Change',
				text: "Confirm change to " + status,
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					this.updateRedem(redem_id, { status: status }).then(res => {
						if (status == 'Submitted') {
							this.createBellNotif('LMS_CASE_REDEMPTION_REQUEST', { case_id: this.activeCase.case_id, customer_name: this.activeCase.name })
							this.createSendEmail('LMS_CASE_REDEMPTION_REQUEST', { case_id: this.activeCase.case_id, customer_name: this.activeCase.name })
						} else if (status == 'Approved') {
							this.createBellNotif('LMS_CASE_REDEMPTION_APPROVAL', { case_id: this.activeCase.case_id, customer_name: this.activeCase.name, action: status })
							this.createSendEmail('LMS_CASE_REDEMPTION_APPROVAL', { case_id: this.activeCase.case_id, customer_name: this.activeCase.name, action: status })

							this.updateCase({recalculate: 'repair_repayment'},this.activeCase.case_id).then((resp) => {
								_gNotif.notifySuccess("Redemption status has been update")
								this.getListing();
								gEventBus.$emit('refresh-cases')
								this.is_loading = false
							}).catch((e) => {
								_gNotif.notifyError('Failed regenerate sattement');
								this.is_loading = false
							})
						}

						if (status != 'Approved'){
							_gNotif.notifySuccess("Redemption status has been update")
							this.getListing();
							gEventBus.$emit('refresh-cases')
							this.is_loading = false
						}
					});
				}
			})
		},
		remove(id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					this.deleteRedem(id).then(resp => {
						this.getListing();
						gEventBus.$emit('refresh-cases')
						_gNotif.notifySuccess('<b>Redemption: </b> - Successfully Deleted.')
					});
				}
			})
		},
		updateApprovalStatus(apv_id, status) {
			swal.fire({
				title: 'Approval Confirmation',
				text: "Confirm to " + status + " this request ?",
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					let params = {
						approve_status: status,
						approve_at: _gHlp.getCurrentDateTime(),
						approve_by: _gAuth.activeUser('id', null)
					}
					this.updateApproval(apv_id, params).then(resp => {
						this.createBellNotif('LMS_CASE_REDEMPTION_APPROVAL', { case_id: this.activeCase.case_id, customer_name: this.activeCase.name, action: status })
						this.createSendEmail('LMS_CASE_REDEMPTION_APPROVAL', { case_id: this.activeCase.case_id, customer_name: this.activeCase.name, action: status })
						this.updateCase({recalculate: 'repair_repayment'},this.activeCase.case_id).then((resp) => {
							this.getListing();
							gEventBus.$emit('refresh-cases')
							this.is_loading = false;
							_gNotif.notifySuccess("Approval Request for redemption has been " + status);
							// this.getCase().then(resp => {
							// 	_gNotif.notifySuccess("Approval Request for redemption has been " + status);
							// 	this.is_loading = false;
							// }).catch(err => {
							// 	this.is_loading = false;
							// });	
						}).catch((e) => {
							this.is_loading = false;
							_gNotif.notifyError('Failed regenerate sattement');
						})

						
					}).catch(err => {
						this.is_loading = false;
					});
				}
			});
		},
		recalculate(redem_id) {
			this.is_loading = true;
			this.updateRedem(redem_id, { recalculate: 1 }).then(res => {
				_gNotif.notifySuccess("Redemption has been recalculate")
				this.getListing();
				gEventBus.$emit('refresh-cases')
				this.is_loading = false
			}).catch(err => {
				this.is_loading = false
			});
		}
	}
}
</script>